import { observer } from "mobx-react-lite";
import { Row, Col } from "antd";
import PhoneHRVSmall from "../dashboard/PhoneHRVSmall";

import "./CadDetail.css";

function CadDetail({ cad, derivedCad }) {
  const stress = cad.stress;
  const forecast = cad.forecast;

  return (
    <div className="CadDetail item-block" key={cad["Incident #"]}>
      <div
        className="color"
        style={{ background: derivedCad.properties.color, border: "1px solid rgba(0,0,0,0.7)" }}
      ></div>{" "}
      <div className="heading">{cad["Incident #"]}</div>{" "}
      <div className="clear"></div>
      <Row className="item-row">
        <Col span={12}>Call Timestamp</Col>
        <Col span={12}>{cad["Call Date/Time"]}</Col>
      </Row>
      <Row className="item-row">
        <Col span={12}>Type</Col>
        <Col span={12}>{cad.Type}</Col>
      </Row>
      {cad.code4_code.map((user) => (
        <div>
          {stress.hasOwnProperty(user) &&
            forecast.hasOwnProperty(user) &&
            stress[user].length > 0 &&
            forecast[user].length > 0 && (
              <div className="cad-block">
                <div>{user}</div>
                <PhoneHRVSmall
                  stress={stress[user]}
                  forecast={forecast[user]}
                  style={{ width: "100%", height: "130px" }}
                />
              </div>
            )}
        </div>
      ))}
    </div>
  );
}

export default observer(CadDetail);
